import type { AnalyticsProvider, TrackInput } from "../types";

// Google Analytics 4 Measurement Protocol.
// Env: GA_MEASUREMENT_ID (G-XXXXXXX), GA_API_SECRET
export const gaAnalyticsProvider: AnalyticsProvider = {
  name: "ga",
  async track(input: TrackInput) {
    const measurementId = readMeasurementId();
    const apiSecret =
      typeof process !== "undefined" ? process.env?.GA_API_SECRET : undefined;
    if (!measurementId || !apiSecret) {
      console.error("[analytics:ga] measurement_id_or_secret_missing");
      return;
    }
    try {
      const clientId = input.userId ?? `${Date.now()}.${Math.random().toString(36).slice(2)}`;
      await fetch(
        `https://www.google-analytics.com/mp/collect?measurement_id=${encodeURIComponent(
          measurementId,
        )}&api_secret=${encodeURIComponent(apiSecret)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            client_id: clientId,
            events: [{ name: input.event, params: input.properties ?? {} }],
          }),
          keepalive: true,
        },
      );
    } catch (err) {
      const msg = err instanceof Error ? err.message : "ga_unknown_error";
      console.error(`[analytics:ga] ${msg}`);
    }
    return undefined;
  },
};

function readMeasurementId(): string | undefined {
  if (typeof process !== "undefined" && process.env?.GA_MEASUREMENT_ID)
    return process.env.GA_MEASUREMENT_ID;
  if (typeof import.meta !== "undefined") {
    const v = (import.meta as { env?: Record<string, string | undefined> }).env
      ?.VITE_GA_MEASUREMENT_ID;
    if (v) return v;
  }
  return undefined;
}
